// Benefit cards as they are SOLD: rows in customers/{cid}/purchases with
// collection === 'benefitcards'. The card definitions live elsewhere; this is about a
// purchased card as the Korttilistaus grid reads it.
//
// Pure by design: no Firebase, no React. Payment reading is in utils/purchases.js, shared
// with the memberships listing.

import { endsBefore } from './purchases'

// The backend's "no end date" marker on `validuntil`. PersonBenefitCards and the card
// listing both special-case it rather than rendering the year 2300.
export const NO_END_SENTINEL = '2300-01-01'

// The end date the card listing actually displays: `validuntil` unless it is the sentinel,
// otherwise `end`.
//
// Note what this does NOT do, and why it differs from the memberships equivalent: it
// ignores `permanent`. A permanent CARD still shows its validuntil in the grid - the card
// list's own end column has no permanent branch - and cards do carry `permanent: true`
// alongside a real past validuntil. Exempting them the way memberships does would hide the
// warning on exactly the rows most likely to be wrong.
export const effectiveEnd = (row) => {
  if (!row) return null
  if (row.validuntil) return row.validuntil === NO_END_SENTINEL ? null : row.validuntil
  return row.end || null
}

// Cards write `start` as 'YYYY.MM.DD' but `validuntil` as 'YYYY-MM-DD', which is precisely
// the mixed-separator case endsBefore is separator-agnostic for.
export const endsBeforeStart = (row) => endsBefore(row && row.start, effectiveEnd(row))
